/**
 * 输出异步加载组件
 */

import {asyncComponent} from './AsyncComponent'

// export const SignUp = asyncComponent(() => import("../view/authorization/signUp/signUp"));
// export const SignIn = asyncComponent(() => import("../view/authorization/signIn/signIn"));
// export const ForgetPWD = asyncComponent(() => import("../view/authorization/forgetPWD/forgetPWD"));
// export const SignUpHome = asyncComponent(() => import("../view/authorization/signUpHome/signUpHome"));

export const CommodityTemplate = asyncComponent(() => import("../view/products/commodityTemplate/commodityTemplate"));
export const HomePageUpdate = asyncComponent(() => import("../view/homePage/homePageUpdate"));

export const LightMedia = asyncComponent(() => import("../view/Solution/LightMedia/lightMedia"));
export const News = asyncComponent(() => import("../view/Solution/News/news"));
export const IntegrationMedia = asyncComponent(() => import("../view/Solution/IntegrationMedia/integrationMedia"));
export const ProvincePlatform = asyncComponent(() => import("../view/Solution/ProvincePlatform/provincePlatform"));

export const Operation = asyncComponent(() => import("../view/Operation/operation"));

export const ContactUs = asyncComponent(() => import("../view/serviceSupport/contactUs/contactUs"));
export const NoticeInfo = asyncComponent(() => import("../view/serviceSupport/noticeInfo/noticeInfo"));





// WEBPACK FOOTER //
// ./src/router/asyn.js